import React from 'react';
import Link from 'react-router-dom/Link';
import MaterialTable, { MTableToolbar } from 'material-table';
import Button from '@material-ui/core/Button';

export function intersperse(arr, sep) {
  if (arr.length === 0) {
    return [];
  }

  return arr.slice(1).reduce(
    function(xs, x, i) {
      return xs.concat([sep, x]);
    },
    [arr[0]]
  );
}

const UnitTable = ({ data, history }) => {
  //Capture Land IDs
  const editableUnits = data.map(u => ({...u}))
  editableUnits.forEach((unit) => {
    const larr = new Set([]);
    unit.wells.map((well) => {
      return well.drilledOn.map((tract) => larr.add(tract.id));
    });
    unit.lands = [...larr].map((i) => i).join(',');
  });

  const columns = [
    {
      title: 'Unit Name',
      field: 'name',
      render: (rowData) => (
        <Link
          to={`/Units/${rowData.id}?name=${encodeURIComponent(rowData.name)}`}
          target='_blank'>
          {rowData.name}
        </Link>
      ),
    },
    {
      title: 'Type',
      field: 'unitType',
    },
    {
      title: 'Operator',
      field: 'currentOperator',
    },
    {
      title: 'Land ID',
      field: 'lands',
      render: (rowData) => {
        const splits = rowData.lands.split(',');
        const Links = splits.map((e) => (
          <Link to={`/Lands/${e}?name=${encodeURIComponent(e.trim())}`} key={e} target='_blank'>
            {e.trim()}
          </Link>
        ));
        return intersperse(Links, ', ');
      },
    },
    {
      title: 'Status',
      field: 'status',
    },
  ];

  return (
    <MaterialTable
      columns={columns}
      data={editableUnits}
      components={{
        Toolbar: (props) => (
          <div
            style={{
              backgroundColor: '#1976d2',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '0 16px',
            }}
          >
            <MTableToolbar {...props} />
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => history.push('/addUnit')}
              style={{ marginLeft: '16px' }}
            >
              Add Unit
            </Button>
          </div>
        ),
      }}
      options={{
        searchFieldAlignment: 'left',
        pageSize: data.length,
        showTitle: false,
        exportButton: true,
        toolbarButtonAlignment: 'left',
        searchFieldStyle: {
          border: 'none',
          paddingTop: '4px',
          paddingBottom: '4px',
          paddingLeft: '8px',
          paddingRight: '8px',
          borderRadius: '4px',
          backgroundColor: '#fff',
          color: '#000',
        },
        headerStyle: {
          backgroundColor: '#1976d2',
          color: '#FFF',
          textAlign: 'left',
          justifyContent: 'center',
          whiteSpace: 'pre',
          position: 'sticky',
          top: 0,
        },
        maxBodyHeight: '85vh',
      }}
    />
  );
};

export default UnitTable;
